import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "labels" }
const _hoisted_2 = { class: "labels__header" }
const _hoisted_3 = {
  key: 0,
  class: "mt-10 mb-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_KeyValue = _resolveComponent("KeyValue")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.containerClass)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass($props.defaultSectionClass)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($props.showLabelTitle)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(!$props.compact ? 'h3' : 'h4'), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_t, { k: "labels.labels.title" })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createTextVNode()),
          ($options.showToggler)
            ? (_openBlock(), _createBlock(_component_ToggleSwitch, {
                key: 1,
                value: $data.toggler,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.toggler) = $event)),
                name: "label-system-toggle",
                "on-label": _ctx.t('labels.labels.show')
              }, null, 8, ["value", "on-label"]))
            : _createCommentVNode("", true)
        ]),
        _cache[4] || (_cache[4] = _createTextVNode()),
        ($props.showLabelDescription)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createVNode(_component_t, { k: "labels.labels.description" })
            ]))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass($options.columnsClass)
        }, [
          _renderSlot(_ctx.$slots, "labels", {}, () => [
            _createVNode(_component_KeyValue, {
              key: "labels",
              "data-testid": "labels-keyvalue",
              value: $data.toggler ? $data.labels.initValue : $data.labels.value,
              "add-label": _ctx.t('labels.addLabel'),
              "add-icon": $props.addIcon,
              mode: $props.mode,
              "read-allowed": false,
              "value-can-be-empty": true,
              "key-errors": $data.labels.keyErrors,
              "use-rc-button": $props.useRcButton,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ($data.labels.update($event, (x) => $props.value.setLabels(x))))
            }, null, 8, ["value", "add-label", "add-icon", "mode", "key-errors", "use-rc-button"])
          ], true)
        ], 2)
      ])
    ], 2),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass($props.compact ? 'compact-spacer' : 'spacer')
    }, null, 2),
    _cache[7] || (_cache[7] = _createTextVNode()),
    ($props.showAnnotations)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass($options.sectionClass)
        }, [
          _createVNode(_component_KeyValue, {
            key: "annotations",
            "data-testid": "annotations-keyvalue",
            value: $data.toggler ? $data.annotations.initValue : $data.annotations.value,
            "add-label": _ctx.t('labels.addAnnotation'),
            "add-icon": $props.addIcon,
            mode: $props.mode,
            title: _ctx.t('labels.annotations.title'),
            "title-protip": $props.annotationTitleTooltip,
            "read-allowed": false,
            "value-can-be-empty": true,
            "key-errors": $data.annotations.keyErrors,
            "disabled-keys": $props.value.readOnlyAnnotationKeys || [],
            "use-rc-button": $props.useRcButton,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ($data.annotations.update($event, (x) => $props.value.setAnnotations(x))))
          }, null, 8, ["value", "add-label", "add-icon", "mode", "title", "title-protip", "key-errors", "disabled-keys", "use-rc-button"])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}